import React from 'react';
import { NamePath } from 'antd/lib/form/interface';
import { PagedSource } from 'hooks/use-table-pagination.hook';
import { IBasicTableColumn } from 'ui-lib';

export type RecordSelectionType = 'single' | 'multiple';

export interface ISelectableTableProps<T> {
    /** Paginated rows, usually from `usePagination` */
    source: PagedSource<T>;
    columns: IBasicTableColumn[];
    selectionType: RecordSelectionType;
    /** Field that identifies a record. Defaults to `uuid`. */
    rowKey?: Extract<keyof T, string>;
    value?: T[];
    onChange?: (records: T[]) => void;
}

export interface IRecordPickerProps<T> extends Omit<ISelectableTableProps<T>, 'value' | 'onChange'> {
    renderRecordTag: (record: T) => React.ReactNode;
    value?: T[];
    onChange?: (records: T[]) => void;
}

export interface IRecordPickerFormItemProps<T> extends Omit<IRecordPickerProps<T>, 'value' | 'onChange'> {
    name: NamePath;
    label: string;
    isRequired?: boolean;
}
